




















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import {
  getNewAppId,
  getNewAppAndoridId,
  addEditIosApp,
  addEditAndroidApp
} from '@/api/files/files-app/filesApp'
import { getTagCategory, addTag, getTagList } from '@/api/files/files-base/filesBase'
import {
  getLangType,
  getLabelMapping,
  getTagMapping,
  getCatagoryMapping,
  getAndroidCategories
} from '@/api/common'
import { Form } from 'element-ui'
import { uploadVideoUrl, deleteFile } from '@/api/upload'
import { ElUploadInternalFileDetail } from '@/typings/files'
import { checkNoneString, resetObjValue2NoneString } from '@/utils/tool'
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'AddApp'
})
export default class extends mixins(DisplayMixin) {
  // api data
  // params: IIOsAddEdit = {
  //   type: 'save',
  //   draftId: 0,
  //   id: 0,
  //   name: '',
  //   developer: '',
  //   tag: [1],
  //   subScript: [],
  //   desc: '',
  //   updateDesc: '',
  //   editorDesc: '',
  //   icon: '',
  //   screenShot: [],
  //   filePath: 'test',
  //   defaultLang: '',
  //   supportLang: '',
  //   categoryId: '',
  //   categoryCode: '',
  //   coverPath: '',
  //   videoPath: '',
  //   screen: 'vertical',
  //   uploadUrl: 'local',
  //   horizontal: '',
  //   switch: false,
  //   price: ''
  // }
  params: any = {
    id: 0,
    name: '',
    developer: '',
    tag: [],
    subScript: [],
    icon: '',
    screenShot: [],
    horizontalScreenShot: [],
    categoryId: 0,
    categoryCode: '',
    price: undefined,
    searchWeight: 0,
    appleArcade: 0,
    descList: [],
    keywords: '',
    description: ''
  }
  uploadUrl = 'local'
  screen = 'vertical'
  supportLang: string[] = []
  currentLang: string = ''
  tableLoading = false
  currentParams: any = {
    // developer: '',
    appName: '',
    desc: '',
    updateDesc: '',
    editorDesc: ''
  }
  paramsList: any = {}
  // data
  fileList: any[] = []
  cateList: ISelectItem[] = []
  options: any[] = []
  addFormVisible: boolean = false
  addParams = {
    id: 0,
    name: '',
    category: '',
    picPath: ''
  }
  rules: any = {
    name: [{ required: true, message: '请输入标签名', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }
  tagOption: any[] = []
  subOption: any[] = []
  categoryOption: any[] = []
  platform: number = 1
  uploadVideoUrl = uploadVideoUrl
  // file response data
  version = ''
  versionCode = 0
  bundleId = ''
  md5 = ''
  size = 0
  ext = ''
  multiLanguage: number[] = []
  score: number = 0
  playUrl: string = ''
  // lifecycle
  created() {
    // if (this.platform === 3) {
    //   this.params.coverPath = this.params.videoPath = ''
    // }
    this.getEditDetail()
    this.getLangType()
    this.getTagList()
    this.getSubList()
    this.getTagCategory()
  }
  // methods
  async getEditDetail() {
    let p = this.$route.query.platform
    this.platform = p === 'ios' ? 1 : 3
    let res
    if (p === 'ios') {
      res = await getNewAppId()
      this.getCateList()
    } else {
      res = await getNewAppAndoridId()
      this.getAndroidList()
    }
    this.params.coverPath = this.params.videoPath = ''
    // this.params.id = res.data.id
  }
  async getLangType() {
    let res = await getLangType()
    this.options = res.data
  }
  async getCateList() {
    let res: any = await getCatagoryMapping()
    this.categoryOption = res.data.dataList
  }
  async getAndroidList() {
    let res: any = await getAndroidCategories()
    this.categoryOption = res.data.dataList
  }
  async getTagList() {
    let res: any = await getTagList({
      page: 1,
      pageCount: 50
    })
    this.tagOption = res.data.dataList
  }
  async getSubList() {
    let res: any = await getTagList({
      page: 1,
      pageCount: 50
    })
    this.subOption = res.data.dataList
  }
  async addIosApp() {
    let res: any = await addEditIosApp(this.params)
    if (+res.status.code === 0) {
      if (this.params.type === 'save') {
        this['$message'].success('保存成功')
      } else {
        this['$message'].success('提交审核成功')
      }
      this.$router.push('/files/files-app/files-app-ios')
    }
    this.tableLoading = false
  }
  async addAndroidApp() {
    let res: any = await addEditAndroidApp(this.params)
    if (res.status.code === 0) {
      if (this.params.type === 'save') {
        this['$message']('已保存至草稿箱')
      } else {
        this['$message'].success('操作成功，已提交审核，请耐心等待')
      }
      this.$router.push('/files/files-app/files-app-android')
    } else {
      this['$message'].error('提交失败，请稍后重试或联系相关人员')
    }
  }
  getPosition(item: any) {
    return item.categoryId
  }
  handleSelect(val: string[]) {
    if (val.length > 0) {
      this.currentLang = val[0]
    } else {
      this.currentLang = ''
    }
    let obj: any = {}
    for (let code of val) {
      if (this.paramsList[code]) {
        obj[code] = this.paramsList[code]
      }
    }
    this.paramsList = obj
    this.currentParams = { ...this.paramsList[this.currentLang] }
  }
  handleLanguageChange(code: string) {
    this.paramsList[this.currentLang] = { ...this.currentParams }
    this.currentLang = code
    if (this.paramsList[code]) {
      this.currentParams = { ...this.paramsList[code] }
    } else {
      this.currentParams = {
        // developer: '',
        appName: '',
        desc: '',
        updateDesc: '',
        editorDesc: ''
      }
    }
  }
  handleCategoryChange(v: number[]) {
    // console.log(v)
    let id: number = v[1]
    for (let i = 0; i < this.categoryOption.length; i++) {
      let child = this.categoryOption[i]
      if (child.value === v[0]) {
        this.params.categoryCode = child.code
        this.params.categoryId = child.value
      }
      const item = this.categoryOption[i]['children']
      if (Array.isArray(item)) {
        item.forEach((term: any) => {
          if (term.value === id) {
            this.params.categoryCode = term.code
            this.params.categoryId = term.value
          }
        })
      }
    }
  }
  handleRead() {
    let url: string = this.params.videoPath
    if (!url.startsWith('http')) {
      url = 'https://' + url
    }
    this.playUrl = decodeURI(url)
    console.log(this.playUrl)
  }
  handeSubmit(type: 'save' | 'commit') {
    this.tableLoading = true
    this.params.type = type
    this.paramsList[this.currentLang] = this.currentParams
    console.log(this.paramsList)
    const arr = Object.keys(this.paramsList).map((langCode: string) => {
      return {
        ...this.paramsList[langCode],
        langCode,
        supportLang: this.supportLang.toString()
      }
    })
    this.params.descList = arr
    this.params.price = +this.params.price
    console.log(arr)
    let tempParams = JSON.parse(JSON.stringify(this.params))
    let isNoneString = checkNoneString(tempParams, [
      'id',
      'draftId',
      'subScript',
      'screenShot',
      'editorDesc',
      'supportLang',
      'developer',
      'updateDesc',
      'videoPath',
      'coverPath',
      'tag',
      'horizontalScreenShot',
      'appleArcade',
      'name'
    ])

    let isArrNeed = this.params.screenShot.length + this.params.horizontalScreenShot.length > 0
    // let isFileValid = this.version !== '' && this.bundleId !== '' && this.md5 !== '' && this.ext !== ''
    // 保存不需要验证
    if (type === 'save') {
      if (this.platform === 1) {
        this.addIosApp()
      } else {
        this.addAndroidApp()
      }
    } else {
      if (isNoneString || !isArrNeed) {
        console.log(this.params)
        this['$message'].warning('请填写完成后再提交!')
        return
      }
      // if (isFileValid) {
      //   this['$message'].warning('文件信息缺失!')
      //   return
      // }
      if (this.platform === 1) {
        this.addIosApp()
      } else {
        this.addAndroidApp()
      }
    }
    this.tableLoading = false
  }
  cancelAddForm() {
    this.addFormVisible = false
  }
  confirmAddForm() {
    if (this.addParams.name.length <= 0) {
      return this.$message.warning('请输入角标名')
    }
    if (!this.addParams.category) {
      return this.$message.warning('请选择角标位置')
    }
    if (!this.addParams.picPath) {
      return this.$message.warning('请上传角标图片')
    }
    this.addTag()
  }
  handleFormClose() {
    this.addParams.name = ''
    this.addParams.category = ''
    this.addParams.picPath = ''
  }
  async addTag() {
    let res: any = await addTag(Object.assign(this.addParams, {
      picPath: this.addParams.picPath.split(domain).pop() as string
    }))
    if (res.status.code === 0) {
      this['$message'].success('添加成功!')
      resetObjValue2NoneString(this.addParams, ['id'])
      this.addFormVisible = false
    } else {
      this['$message'].error('添加失败!')
    }
  }
  async getTagCategory() {
    let res = await getTagCategory()
    this.cateList = res.data
  }
  beforeFileUpload(file: ElUploadInternalFileDetail) {
    console.log(file)
  }
  handleFileSuccess(res: any, file: ElUploadInternalFileDetail) {
    console.log(res)
    if (res.status.code === 0) {
      this['$message'].success('文件上传成功')
      this.params.videoPath = res.data.path
      this.version = res.data.version
      this.versionCode = res.data.versionCode
      this.bundleId = res.data.bundleId
      this.md5 = res.data.md5
      this.size = res.data.size
      this.ext = res.data.ext
    }
  }
  handleFileError() {
    this['$message'].error('文件类型不支持，IOS支持ipa，Android支持apk和tpk')
  }
  handleExceed() {
    this['$message'].warning('最多只能上传一个文件!')
  }
  addLang() {
    let query: IQuery = {
      id: this.params.id,
      platform: this.$route.query.platform
    }
    this['$router'].push({
      name: 'MultiLanguage',
      query: query
    })
  }
  async handleRemove(file: ElUploadInternalFileDetail) {
    console.log(file)
    let path: string = file.response.data.path
    this.params.videoPath = ''
    let res: any = await deleteFile({
      path: path,
      id: this.params.id
    })
    console.log(res)
    if (res.status.code === 0) {
      this['$message'].success('文件删除成功')
    } else {
      this['$message'].error('文件删除失败')
    }
  }
  toggleSelect(id: number) {
    let index: number = this.params.subScript.indexOf(id)
    if (index > -1) {
      this.params.subScript.splice(index, 1)
    } else {
      this.params.subScript.push(id)
    }
    if (this.params.subScript.length > 1) {
      this.params.subScript.shift()
    }
  }

  get selectedLanguages() {
    return this.options.filter((item: any) => this.multiLanguage.includes(item.code))
  }
}
